export default __webpack_public_path__ + "static/media/blogimage10.b8f42473.png";